<script>
import {
    loadScript
} from '@paypal/paypal-js'

export default {
    name: 'Checkout-Payment',
    beforeCreate: function () {
        loadScript({
            'client-id': CLIENT_ID,
            'disable-funding': "credit,venmo,sepa,bancontact,eps,giropay,ideal,mercadopago,mybank,p24,sofort",
            'currency': "EUR",
            'components': "buttons"
        }).then((paypal) => {
            paypal
                .Buttons({
                    createOrder: this.createOrder,
                    onApprove: this.onApprove,
                    style: {
                        color: "black"
                    }
                }).render('#paypal-button-container');
        });
    },
    data() {
        return {
            paid: false
        };
    },
    props: {
        cartTotal: {
            type: Number,
            default: 5.99,
        },
    },
    methods: {
        createOrder: function (data, actions) {
            return actions.order.create({
                purchase_units: [{
                    amount: {
                        value: this.cartTotal.toFixed(2),
                        currency_code: "EUR",
                        breakdown: {
                            item_total: {
                                value: this.cartTotal.toFixed(2),
                                currency_code: "EUR"
                            }
                        }
                    },
                    description: 'NIGHTRIDERZ / PREMIUM',
                    items: [{
                        name: "NIGHTRIDERZ / PREMIUM",
                        unit_amount: {
                            value: this.cartTotal.toFixed(2),
                            currency_code: "EUR"
                        },
                        quantity: "1",
                        category: "DIGITAL_GOODS"
                    }]
                }],
                application_context: {
                    shipping_preference: "NO_SHIPPING"
                }
            });
        },
        onApprove: function (data, actions) {
            return actions.order.capture().then(() => {
                this.$emit('capture', data)
            });
        },
    },
};
const CLIENT_ID = 'AeE3Ipwciz1ocAShf9yxOnQZvH1DylB7gMjqmhIU85kyJEEtNAxXxhXRM3EF7VUjWHBGEBJ7KnjGGLIF';
</script>

<template>
    <div v-if="!paid" id="paypal-button-container"></div>
    <div v-else id="confirmation">Order complete!</div>
</template>

<style>
#confirmation {
    color: #ffd700;
    text-align: center;
    font-size: 1.2rem;
    font-weight: 600;
    margin-top: 1rem;
}
</style>